import getCartSelect from 'modules/cart/redux/selectors/get-cart'
import { createSelector } from 'reselect'

const isLoadedCartSelect = createSelector(
  getCartSelect,
  (cart) => !!cart?.items
)

export default isLoadedCartSelect
